<template>
  <div>
    <div class="d-inline-flex mb-4">
      <div class="form-check mr-3" v-if="sound_fields.length">
        <input
          class="form-check-input select-all mt-0"
          type="checkbox"
          v-model="selectAll"
        />
      </div>
      <h4 class="mr-3 mb-0">
        Sound
      </h4>
      <div class="d-flex align-items-center">
        <span class="cursor-pointer">
          <img
            src="~@/assets/addplus_icon.svg"
            width="20"
            class="heading-icon"
            @click="showAddNewSoundModal"
          />
        </span>
        <span
          v-if="sound_fields.length && isSelected"
          class="cursor-pointer ml-3"
          @click="deleteAllSound()"
        >
          <i class="fa fa-trash"></i>
        </span>
      </div>
    </div>
    <div v-for="(sounditem, index) in sound_fields" :id="sounditem.id" :key="index" class="mb-3 inspectorElements">
      <div class="fields-wrapper is-divider is-multi-node">
        <div class="form-check select-single">
          <input
            class="form-check-input"
            type="checkbox"
            @change="checkSingleSelect"
            v-model="sounditem.sound.selectSingle"
          />
        </div>
        <div
          class="action-buttons"
          v-if="!sounditem.sound.isCopied || sounditem.sound.selectSingle"
        >
          <span
            v-if="!sounditem.sound.isCopied"
            class="action-item "
            @click="copySound(index, sounditem)"
          >
            <i class="fa fa-copy"></i>
          </span>
          <span
            v-if="sounditem.sound.selectSingle"
            class="action-item"
            @click="deleteSound(index, sounditem)"
          >
            <i class="fa fa-trash"></i>
          </span>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label for="animation_selector" class="col-sm-3 col-form-label">
                Sound Selector
              </label>
              <div class="col-sm-9">
                <select id="animation_selector"
                  v-model="sounditem.sound.mediaId"
                  @change="changeSelectedSound(index, sounditem.sound)"
                  class="custom-select"
                >
                  <option  v-for="(soundSelector, key) in sounds"
                    :key="key"
                    class="custom-select"
                    :value="key"
                  >
                  {{soundSelector.name}}
                  </option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Sound Type
              </label>
              <div class="col-sm-9">
                <select
                  placeholder="Select Sound Type"
                  class="custom-select"
                  v-model="sounditem.sound.soundType"
                >
                  <option value="2D">2D</option>
                  <option value="3D">3D</option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="start_time" class="col-sm-3 col-form-label">
                Start Time
              </label>
              <div class="col-sm-9">
                <input 
                  type="number" 
                  class="form-control" 
                  id="start_time" 
                  v-model="sounditem.sound.startTime"
                  @change="setDuration(index)"
                >
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="end_time" class="col-sm-3 col-form-label">
                End Time
              </label>
              <div class="col-sm-9">
                <input 
                  type="number" 
                  class="form-control" 
                  id="end_time" 
                  v-model="sounditem.sound.endTime"
                  @change="setDuration(index)"
                >
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Duration
              </label>
              <div class="col-sm-9">
                <input 
                  type="number" 
                  :value="(sounditem.sound.endTime - sounditem.sound.startTime).toFixed(2)" 
                  class="form-control" 
                  id="animation_duration_e"
                  readonly
                >
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Spatial Blend
              </label>
              <div class="col-sm-9">
                <input type="range" min="0" max="1" step="0.5" v-model="sounditem.sound.spatialBlend">
                <span class="ml-2">{{ sounditem.sound.spatialBlend }}</span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label for="select_audio" class="col-sm-3 col-form-label">
                Audio Options
              </label>
              <div class="col-sm-9">
                <template
                  v-if="!sounditem.sound.hasOwnProperty('isAudioPlaying') || !sounditem.sound.isAudioPlaying">
                  <button
                    @click="playSelectedSound(index)"
                    class="btn btn-outline-success"
                    id="select_audio_duration_s"
                  >
                    <i class="fa fa-play"></i>
                  </button>
                </template>
                <template
                  v-if="sounditem.sound.hasOwnProperty('isAudioPlaying') && sounditem.sound.isAudioPlaying">
                  <button @click="pauseSelectedSound(index)"
                          class="btn btn-outline-warning" id="select_audio_duration_pause">
                    <i class="fa fa-pause pause"></i>
                  </button>
                </template>
                <button @click="stopSelectedSound(index)"
                        class="btn btn-outline-danger ml-4" id="select_audio_duration_stop">
                  <i class="fa fa-stop"></i>
                </button>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Loop count
              </label>
              <div class="col-sm-9">
                <input type="range" min="0" max="10" step="0.5" v-model="sounditem.sound.loopCount">
                <span class="ml-2">{{ sounditem.sound.loopCount }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Volume
              </label>
              <div class="col-sm-9">
                <input type="range" @change="updateVolume(index)" min="0" max="10" step="0.5" v-model="sounditem.sound.volume">
                <span class="ml-2">{{ sounditem.sound.volume }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Pitch
              </label>
              <div class="col-sm-9">
                <input type="range" min="0" max="10" step="0.5" v-model="sounditem.sound.pitch">
                <span class="ml-2">{{ sounditem.sound.pitch }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Minimum Distance
              </label>
              <div class="col-sm-9">
                <input type="number" v-model="sounditem.sound.minimumDistance" class="form-control">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Maximum Distance
              </label>
              <div class="col-sm-9">
                <input type="number" v-model="sounditem.sound.maximumDistance" class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row form-group mt-4">
      <div class="col-12 text-center">
        <button class="btn btn-primary mr-3" v-if="sound_fields.length" @click="saveToDB()">Save</button>
      </div>
    </div> -->

    <template v-if="showModal">
      <div id="character-modal" class="modal" tabindex="-1" role="dialog" data-backdrop="static"
            data-keyboard="false">
        <div class="modal-dialog modal-lg" role="document">

          <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
              <span aria-hidden="true">&times;</span>
            </button>

            <div class="modal-header">
              <h4 class="text-center font-size-20">
                Sound Modal
              </h4>
              <div class="clearfix"></div>
            </div>

            <div class="modal-body">
              <div class="form-row">
                <div class="form-group col-12">
                  <p class="font-weight-bold">Select Sound</p>
                  <div class="models-wrapper">
                    <div v-for="(sound,index) in sounds"
                        :key="index"
                        class="model-item"
                        :class="{'active': activeChar === sound.name }"
                    >
                      <div class="col-1">
                        <button v-if="sound.hasOwnProperty('showStopButton') && !sound.showStopButton" @click="playSound(index)"
                                class="btn btn-outline-success" id="select_audio_duration_s">
                          <i class="fa fa-play"></i>
                        </button>
                        <button v-else @click="stopSound(index)"
                                class="btn btn-outline-danger" id="select_audio_duration_e">
                          <i class="fa fa-stop"></i>
                        </button>
                      </div>
                      <p>{{ sound.name }}</p>
                      <div class="col-1">
                        <button @click="updatedSelectedSound(index)"
                                class="btn btn-primary" id="select_audio_duration_e">Select
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>

import {mapActions, mapState} from 'vuex'
import {Howl} from 'howler'
import $ from 'jquery'
import {uuid} from 'vue-uuid'
import {db} from '../../../../../firebaseDB'

export default {
  components: {},
  data () {
    return {
      selectAll: false,
      sound_fields: [],
      currentLoop: 0,
      currentSelectedSound: '',
      activeSound: '',
      howl: '',
      selectedSoundStart: 0,
      selectedSoundEnd: '',
      sampleSound: '',
      showModal: false,
      activeChar: 'Select Sound',
      isCopied: false,
      selectSingle: false,
      currentIndex: null,
      charList: [],
      playSelectedOne: '',
      activeChar: {},
      objectId: '',
      isSelected: false
    }
  },
  created () {
      this.listSounds()
  },

  methods: {
    ...mapActions([
      'listSounds'
    ]),
    addNewSound (index) {
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      let start = 0
      let end = 0
      if (this.sounds[index].hasOwnProperty('duration') && this.sounds[index].duration <= duration && this.timeLineCursor >= this.activeChar.startTime) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(this.sounds[index].duration)).toFixed(2)
      } else if (duration >= 2 && this.timeLineCursor >= this.activeChar.startTime) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(duration)).toFixed(2)
        duration = parseFloat(duration).toFixed(2)
      } else {
        end = this.lastElementEndTime 
          ? (this.sounds[index].hasOwnProperty('duration') 
            ? (parseFloat(this.sounds[index].duration) + this.lastElementEndTime).toFixed(2) 
            : parseFloat(this.lastElementEndTime).toFixed(2))
            : parseFloat(this.activeChar.startTime) + 5;
        start = this.lastElementEndTime ? parseFloat(this.lastElementEndTime).toFixed(2) : parseFloat(this.activeChar.startTime)
        duration = (end - start).toFixed(2)
      }
      let id =  uuid.v1()
      this.sound_fields.push({
        elementType: 'Sound',
        id: id,
        sound: {
          id: id,
          mediaId: index,
          name: this.sounds[index].name,
          soundType: this.sounds[index].soundType || '2D',
          objectId: id,
          objectName: this.sounds[index].name,
          startTime: start,
          endTime: end,
          mediaLength: this.sounds[index].hasOwnProperty('duration') ? this.sounds[index].duration : 0,
          duration: duration,
          minimumDistance: 0,
          maximumDistance: 0,
          loopCount: this.sounds[index].hasOwnProperty('loopCount') ? this.sounds[index].loopCount : 1,
          volume: this.sounds[index].hasOwnProperty('volume') ? this.sounds[index].volume : 0.5,
          pitch: this.sounds[index].hasOwnProperty('pitch') ? this.sounds[index].pitch : 1,
          audio: this.sounds[index].audio,
          audioUrl: this.sounds[index].audio.audioURL,
          audioType: this.sounds[index].audioType || 'MPEG',
          spatialBlend: this.sounds[index].hasOwnProperty('spatialBlend') ? this.sounds[index].spatialBlend : 0,
          isCopied: false,
          selectSingle: false,
          isAudioPlaying: false,
          parentObjectId: this.activeChar.objectId
        }
      })
      if(this.sampleSound) {
        this.sampleSound.stop()
      }
            
      this.sampleSound = new Howl({
        src: [this.sounds[index].audio.audioURL],
        format: ['mp3'],
        onload: function () {
          this.onLoadEvent(this.sound_fields.length - 1)
        }.bind(this)
      })
      this.reflext()
      
    },
    onLoadEvent(index) {
      console.log(this.sound_fields[index].sound)
      let duration = this.sound_fields[index].sound.duration != 0 && parseFloat(this.sound_fields[index].sound.duration) < this.sampleSound.duration(0).toFixed(2) ? this.sound_fields[index].sound.duration : this.sampleSound.duration(0).toFixed(2) 
      this.sound_fields[index].sound.duration = duration;
      this.sound_fields[index].sound.mediaLength = this.sampleSound.duration(0).toFixed(2);
      this.sound_fields[index].sound.endTime = (parseFloat(this.sound_fields[index].sound.startTime) + parseFloat(duration)).toFixed(2);
    },
    reflext () {
      let newChar =
        this.characters &&
        this.characters.map(char =>
          char.objectId === this.activeChar.objectId
            ? {
              ...char,
              characterElements: 
              char.characterElements ? [
                ...char.characterElements.filter(
                  el => !el.hasOwnProperty('sound')
                ),
                ...this.sound_fields
              ] :  
              [ ...this.sound_fields ]
            }
            : {...char}
        )
      this.$store.dispatch('updateCharacters', newChar)
    },
    copySound (index, item) {
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      let start = 0
      let end = 0
      if (duration >= item.sound.duration && this.timeLineCursor >= this.activeChar.startTime) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(item.sound.duration)).toFixed(2)
        duration = parseFloat(item.sound.duration).toFixed(2)
      } else {
        end = this.lastElementEndTime ? (this.lastElementEndTime + parseFloat(item.sound.duration)).toFixed(2) : parseFloat(this.activeChar.startTime) + parseFloat(item.sound.duration)
        start = this.lastElementEndTime ? this.lastElementEndTime.toFixed(2) : parseFloat(this.activeChar.startTime)
        duration = parseFloat(item.sound.duration).toFixed(2)
      }
      this.sound_fields[index].sound.isCopied = !this.sound_fields[index].sound.isCopied
      let id = uuid.v1()
      this.sound_fields.push({
        elementType: 'Sound',
        id: id,
        sound: {
          objectId: id,
          objectName: item.sound.name,
          name: item.sound.name,
          soundType: item.sound.soundType,
          startTime: start,
          endTime: end,
          duration: parseFloat(item.sound.duration),
          mediaLength: parseFloat(item.sound.mediaLength),
          minimumDistance: item.sound.minimumDistance,
          maximumDistance: item.sound.maximumDistance,
          loopCount: item.sound.loopCount,
          mediaId: item.sound.mediaId,
          volume: item.sound.volume,
          pitch: item.sound.pitch,
          spatialBlend: item.sound.spatialBlend,
          audio:  item.sound.audio,
          audioUrl: item.sound.audio.audioURL,
          audioType: item.sound.audio.audioType,
          parentObjectId: this.activeChar.objectId,
          isCopied: false,
          selectSingle: false,
          isAudioPlaying: false,
        }
      })
      this.reflext()
    },
    deleteSound (key, item) {
      var idx = this.sound_fields.indexOf(item)
      if (idx > -1) {
        this.sound_fields.splice(idx, 1)
      }
      this.reflext()
      this.$root.$emit('removeSubnode', item.id, 'Sound', this.activeChar.objectId)
    },
    nextElement (time) {
      let duration = 5
      let min = 99999999
      let element = this.sound_fields.filter((el) => {
        return (parseFloat(el.sound.startTime) <= time && parseFloat(el.sound.endTime) > time)
      })
      if (element.length) {
        return 0;
      }
      element = this.sound_fields.forEach((el) => {
        if (parseFloat(el.sound.startTime) >= time && parseFloat(el.sound.startTime) <= min) {
          duration = parseFloat(el.sound.startTime) - time
          min = parseFloat(el.sound.startTime)
        }
      })
      return duration;
    },
    changeSelectedSound (index, sound) {
      let selected = this.sounds[sound.mediaId]
      this.sound_fields[index].sound.soundType = selected.soundType || sound.soundType
      this.sound_fields[index].sound.name = selected.name
      this.sound_fields[index].sound.objectName = selected.name
      this.sound_fields[index].sound.mediaLength = selected.hasOwnProperty('duration') ? selected.duration : 0
      this.sound_fields[index].sound.audio = selected.audio,
      this.sound_fields[index].sound.audioUrl = selected.audio.audioURL,
      this.sound_fields[index].sound.audioType = selected.audioType || sound.audioType
    },
    playSelectedSound (index) {
      if (this.currentSelectedSound && this.playSelectedOne) {
        this.stopSelectedSound(index)
      }
      console.log(this.sound_fields[index])
      this.sound_fields[index].sound.isAudioPlaying = true
      this.playSelectedOne = new Howl({
        src: [this.sound_fields[index].sound.audio.audioURL],
        format: ['mp3'],
        volume: 0.5
      })
      // this.sound_fields[index].sound.endTime = this.sound_fields[index].sound.startTime + this.playSelectedOne._duration
      // this.sound_fields[index].sound.duration = this.playSelectedOne._duration
      this.playSelectedOne.play()
    },
    pauseSelectedSound (index) {
      this.sound_fields[index].sound.isAudioPlaying = false
      this.playSelectedOne.pause()
    },
    stopSelectedSound (index) {
      this.sound_fields[index].sound.isAudioPlaying = false
      this.sound_fields[index].showStopButton = false
      this.playSelectedOne.stop()
    },
    setDuration (index) {
      this.sound_fields[index].sound.duration = this.sound_fields[index].sound.endTime - this.sound_fields[index].sound.startTime
    },
    updateVolume (index) {
      if (this.playSelectedOne) {
        this.playSelectedOne.volume([this.sound_fields[index].sound.volume / 10])
      }
    },
    onEndEvent () {
      this.currentLoop += 1
      if (this.currentLoop < this.no_of_loops) {
        this.playSound()
      } else {
        this.currentLoop = 0
      }
    },
    constructHowlObject (newVal, endDuration) {
      if (newVal) {
        this.howl = new Howl({
          src: [this.sounds[this.currentSelectedSound].audio.audioURL],
          format: ['mp3'],
          volume: 0.1,
          sprite: {
            track01: [this.selectedSoundStart * 1000, endDuration * 1000]
          },
          onend: function () {
            this.onEndEvent()
          }.bind(this),
        })

        if (this.soundType === '3D') {
          let x = Math.round(100 * (2.5 - (Math.random() * 5))) / 100
          let y = Math.round(100 * (2.5 - (Math.random() * 5))) / 100
          this.howl.pos(x + 0.5, y + 0.5, -0.5)
          this.howl.pannerAttr({
            panningModel: 'HRTF',
            refDistance: 0.8,
            rolloffFactor: 2.5,
            maxDistance: 10000,
            distanceModel: 'exponential'
          })
        }
      }
    },
    updatedSelectedSound (value) {
      this.end_duration = null
      this.currentSelectedSound = value
      this.constructHowlObject(value)
      this.closeModal()
      this.addNewSound(value)
    },
    playSound (value) {
      if (this.sampleSound) {
        this.sampleSound.stop()
      }
      this.sounds[value].showStopButton = true
      this.sampleSound = new Howl({
        src: [this.sounds[value].audio.audioURL],
        format: ['mp3'],
        volume: 0.5
      })
      this.sampleSound.play()
    },
    stopSound (index) {
      this.sounds[index].showStopButton = false
      this.sampleSound.stop()
    },
    clearSelectedSound () {
      this.stopSelectedSound()
      this.currentSelectedSound = ''
      this.selectedSoundEnd = ''
    },
    saveToDB () {
      let _this = this
      let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
      let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));
      tRef.once('value').then(async snapshot => {
        let storyData = snapshot.val();
        let nodeDataArray = ((storyData && storyData.diagram) ? storyData.diagram.nodeDataArray || [] : [])
        .filter(n => n.key !== 'Start')
        .filter(n => n.category == 'Scene');
        let selectedNodePosition = nodeDataArray.findIndex(n => n.key == selectedLogic.key);
        let json = snapshot.val().json
        let characterElements = []
        for (const snapshotkey in json.mainStory.nodes[selectedNodePosition].nodeElements) {
          if (json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].hasOwnProperty('character') && json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.objectId == _this.currentIndex) {
            for (const innerKey in json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements) {
              if (json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements[innerKey].elementType === 'Sound') {
                delete json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements[innerKey]
              } else {
                characterElements.push(json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements[innerKey])
              }
            }
            const data = []
            _this.sound_fields.forEach((value, key) => {
              delete value.sound.audio
              delete value.sound.isAudioPlaying
              delete value.sound.isCopied
              delete value.sound.selectSingle
              characterElements.push({
                elementType: value.elementType,
                id: value.id,
                sound: {...value.sound}
              })
            })
            json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements = characterElements
            let updates = {}
            updates[localStorage.getItem('storyId') + `/json`] = json
            db.ref('stories')
              .update(updates)
              .then(snapshot => {
                data.forEach((value, key) => {
                  console.log(value)
                  this.tts_fields[key].textToSpeech.voiceEffects = value.voiceEffects
                  this.tts_fields[key].textToSpeech.voiceList = value.voiceList
                })
                _this.showSuccessToast()
              })
              .catch(e => {
                _this.showErrorToast()
              })
            this.$parent.activeComponent = 'sound'
          }
        }
      })
    },
    showSuccessToast () {
      this.$toast('Sound inspector data saved', {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast () {
      this.$toast('Sound inspector data failed', {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    showAddNewSoundModal: function () {
      this.showModal = true
      this.$nextTick(() => {
        $('#character-modal').modal('show')
      })
    },
    closeModal () {
      $('.modal').modal('hide')
      this.showModal = false
    },
    deleteAllSound () {
      this.selectAll = false
      this.sound_fields = this.sound_fields.filter(value => {
        return !value.sound.selectSingle
      })
      this.reflext()
    },
    checkSingleSelect () {
      this.sound_fields.forEach(value => {
        if (value.sound.selectSingle) {
          this.isSelected = true
        }
      })
    },
    // changeModelInspector () {
    //   let hasSound = false
    //   for (const key in this.charList) {
    //     if (this.charList[key].character.objectId == this.currentIndex) {
    //       this.sound_fields = []
    //       console.log(this.charList[key].character.characterElements)
    //       for (const valueKey in this.charList[key].character.characterElements) {
    //         if (this.charList[key].character.characterElements[valueKey].elementType === 'Sound') {
    //           hasSound = true
    //           this.sound_fields.push(this.charList[key].character.characterElements[valueKey])
    //           this.currentIndex = this.charList[key].character.objectId
    //         }
    //       }
    //     }
    //   }
    // }
    changeSelectedObject () {
      this.sound_fields  = []
      this.characters.map((val, index) => {
        if (val.active) {
          this.activeChar = val
          if (val.characterElements) {
            val.characterElements.forEach(element => {
              if (element.elementType === 'Sound') {
                element.sound.audio =  this.sounds[element.sound.mediaId].audio
                element.sound.isCopied = false
                element.sound.selectSingle = false
                element.sound.isAudioPlaying = false
                this.sound_fields.push(element)
              }
            });
          }
        }
      })
    }
  },
  async mounted () {
    // let _this = this
    // let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
    // let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));
    // tRef.on('value', snapshot => {
    //   let storyData = snapshot.val();
    //     let nodeDataArray = ((storyData && storyData.diagram) ? storyData.diagram.nodeDataArray || [] : [])
    //     .filter(n => n.key !== 'Start')
    //     .filter(n => n.category == 'Scene');
    //     let selectedNodePosition = nodeDataArray.findIndex(n => n.key == selectedLogic.key);
    //   this.charList = []
    //   if (!snapshot.val().json.mainStory.nodes[selectedNodePosition].nodeElements) {
    //     _this.addNewSound()
    //   } else {
    //     let hasSound = false
    //     snapshot.val().json.mainStory.nodes[selectedNodePosition].nodeElements.forEach(value => {
    //       if (value.elementType === 'Character') {
    //         this.charList.push(value)
    //         if (!_this.currentIndex) {
    //           for (const valueKey in value.character.characterElements) {
    //             if (value.character.characterElements[valueKey].elementType === 'Sound') {
    //               hasSound = true
    //               _this.currentIndex = value.character.objectId
    //               _this.sound_fields.push(value.character.characterElements[valueKey])
    //               _this.sound_fields[_this.sound_fields.length - 1].sound.audio = _this.sounds[value.character.characterElements[valueKey].sound.mediaId].audio
    //               _this.sound_fields[_this.sound_fields.length - 1].sound.isAudioPlaying = false
    //             }
    //           }
    //         } else {
    //           if (_this.currentIndex === value.character.objectId) {
    //             _this.sound_fields = []
    //             for (const valueKey in value.character.characterElements) {
    //               if (value.character.characterElements[valueKey].elementType === 'Sound') {
    //                 hasSound = true
    //                 _this.sound_fields.push(value.character.characterElements[valueKey])
    //                 _this.sound_fields[_this.sound_fields.length - 1].sound.audio = _this.sounds[value.character.characterElements[valueKey].sound.mediaId].audio
    //                 _this.sound_fields[_this.sound_fields.length - 1].sound.isAudioPlaying = false
    //               }
    //             }
    //           }
    //         }
    //       }
    //     })
    //   }
    //   _this.currentIndex = _this.charList[0].character.objectId
    //   if (this.sound_fields.length < 1) {
    //     this.showAddNewSoundModal()
    //   }
    // })
    this.sound_fields  = []
    this.characters.map((val, index) => {
      if (val.active) {
        this.activeChar = val
        if (val.characterElements) {
          val.characterElements.forEach(element => {
            if (element.elementType === 'Sound') {
              element.sound.isCopied = false
              element.sound.selectSingle = false
              element.sound.isAudioPlaying = false
              this.sound_fields.push(element)
            }
          });
          setTimeout(() => {
            let newArray = []
            this.sound_fields.forEach((value, index) => {
              value.sound.audio =  this.sounds[value.sound.mediaId].audio
              newArray.push(value)
            })
            this.sound_fields = newArray
          }, 1000)
        }
      }
    })
  },
  watch: {
    selectAll: function (val) {
      this.isSelected = !!val
      if (this.sound_fields) {
        this.sound_fields.forEach(value => {
          value.sound.selectSingle = val
        })
      }
    },
    characters (val) {
      this.changeSelectedObject();
    },
  },
  computed: {
    lastElementEndTime () {
      let max = 0
      this.sound_fields.forEach((el) => {
        if (parseFloat(el.sound.endTime) >= max) {
          max = parseFloat(el.sound.endTime)
        }
      })
      return max;
    },
    ...mapState([
      'sounds',
      'characters',
      'timeLineCursor'
    ]),
  }
}
</script>
<style>
.selectSound {
  cursor: pointer;
}
.pause {
  margin-left: 2.5px;
  margin-right: 2.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/character/sound.vue